import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';

import ButtonIcon from '../../../Icons/ButtonIcon';
import { CardContent } from '../../../Card/Card';
import * as Styled from './GiftMessageCardEdit.styled';
import { setGiftMessage } from '../../../../services/storefront/cart';
import LinkText from '../../../LinkText/LinkText';

/**
 * Displays a gift message with the option to edit it
 */
const GiftMessageCardEdit = ({ note, onEditClick, className }) => {
  const client = useApolloClient();
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('Message Removed');
  const [hasError, setHasError] = useState(false);

  const handleDeleteClick = async (e) => {
    e?.preventDefault();
    setIsDeleting(true);

    await setGiftMessage('', client).catch(() => {
      setHasError(true);
      setDeleteMessage('Something went wrong, please try again.');
    });
  };

  return (
    <Styled.Container className={className}>
      {isDeleting && (
        <Styled.RemovedOverlay error={hasError}>
          {deleteMessage}
        </Styled.RemovedOverlay>
      )}
      <Styled.Card>
        <CardContent>
          <Styled.CardHeader>
            <Styled.Title>Gift Message</Styled.Title>
            <LinkText onClick={onEditClick} size="Mini" underline data-track-label="edit gift message">
              edit
            </LinkText>
          </Styled.CardHeader>
          <Styled.Description>{note}</Styled.Description>
        </CardContent>
        <ButtonIcon
          variant="defaultLight"
          data-track-label="remove gift message"
          aria-label="delete gift message"
          data-testid="GiftMessageDeleteBtn"
          name="trash"
          onClick={handleDeleteClick}
        />
      </Styled.Card>
    </Styled.Container>
  );
};

GiftMessageCardEdit.propTypes = {
  /**
   * Gift Message note attached to the cart
   */
  note: PropTypes.string.isRequired,
  /**
   * call back to open Gift Message Dialog
   */
  onEditClick: PropTypes.func.isRequired,
  /**
   * optional styled overrides
   */
  className: PropTypes.string
};

GiftMessageCardEdit.defaultProps = {
  className: undefined
};

export default GiftMessageCardEdit;
